import { styled } from '@mui/material';

export const NoRemarksWrapper = styled('div')({
  padding: '0.5rem 1rem',
});

export const RemarksRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const RemarksHeader = styled('div')({
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: '0.5rem 1rem 0',
  marginBottom: '1rem',
});

export const RemarksList = styled('div')({
  flexGrow: 1,
  overflow: 'hidden',
});

export const RemarksListContent = styled('div')({
  height: '100%',
  overflow: 'auto',
  padding: '0 1rem',
});
